import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { Provider } from "./components/ui/provider";
import "./styles/global.css";

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <Provider>
      <App />
    </Provider>
  </StrictMode>
);

if (import.meta.hot) {
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);
} else {
  createRoot(elem).render(app);
}
